// ControlVerticalSliderFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import HorizontalSliderControlView from 'advanced-inputs/HorizontalSliderControlView.js';
import ControlModel    from 'ControlModel.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

class ControlHorizontalSliderFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {
        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.minValue = 0;
        attributes.maxValue = 10;
        attributes.sliderColor = '#CCCCCC';
        attributes.snapInterval = 1;        
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.value = 1;
        attributes.tickInterval = 2;
        attributes.maxText = 'Max';
        attributes.minText = 'Min';
        attributes.tickColor = '#000000';
        attributes.resizePadding = 2;
		attributes.minWidth = 75;
		attributes.minHeight = 44;
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
			{key:"minText", label:"Min Text"},
			{key:"maxText", label:"Max Text"}
        ];


        return new HorizontalSliderControlView({
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos,
            factoryKey: factoryKey,
            id: attributes.id
        });
    }

    createChildAttributes(factoryKey, pos){
        return _.merge(super.createChildAttributes(factoryKey, pos), {stepLength:1, steps:10, distance:10, scaleColor:"#000000"});
    }
}

const controlHorizontalSliderFactory = new ControlHorizontalSliderFactory();
export default controlHorizontalSliderFactory;